import { createFileRoute } from "@tanstack/react-router";
import NamiWalksPage from "@/pages/NamiWalksPage";
export const Route = createFileRoute("/namiwalks")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "NAMIWalks Broward 2026 | Join Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Neuro Wellness TMS sponsors NAMIWalks to support mental health awareness. Join our team in Coral Springs, FL to fight stigma and support depression care.",
        },
        {
          property: "og:title",
          content: "NAMIWalks Broward 2026 | Join Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Neuro Wellness TMS sponsors NAMIWalks to support mental health awareness. Join our team in Coral Springs, FL to fight stigma and support depression care.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/namiwalks",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/namiwalks",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <NamiWalksPage />;
}
